export const toolIcon = {
    'ansible-lint': 'ansible',
    bandit: 'python',
    'cfn-lint': 'cloudformation',
    codeac: 'codeac',
    cpd: 'copy',
    cppcheck: 'cpp',
    detekt: 'kotlin',
    eslint: 'js',
    ethlint: 'solidity',
    flake8: 'python',
    flow: 'js',
    'graphql-schema-linter': 'graphql',
    hadolint: 'docker',
    'haml-lint': 'ruby',
    jscpd: 'copy',
    'kube-linter': 'kubernetes',
    'kube-score': 'kubernetes',
    kubeval: 'kubernetes',
    'npm-audit': 'js',
    'yarn-audit': 'js',
    phpcpd: 'php',
    phpcs: 'php',
    phpmd: 'php',
    phpstan: 'php',
    'php-security-checker': 'php',
    pmd: 'java',
    psscript: 'powershell',
    'puppet-lint': 'puppet',
    pylint: 'python',
    revive: 'go',
    rubocop: 'ruby',
    'salt-lint': 'salt-stack',
    'sass-lint': 'sass',
    scsslint: 'sass',
    'security-code-scan': 'csharp',
    shellcheck: 'shell',
    'sonar-csharp': 'csharp',
    'svelte-check': 'svelte',
    swiftlint: 'swift',
    tailor: 'swift',
    terraform: 'terraform',
    tflint: 'terraform',
    tfsec: 'terraform',
    tslint: 'ts',
};
export const toolIconByIssueName = {
    'osv-scanner': (issueName) => {
        if (issueName.includes('NPM Vulnerability')) {
            return 'js';
        }
        else if (issueName.includes('Packagist Vulnerability')) {
            return 'php';
        }
        return null;
    },
};
